<!--
    描述：指标分析tab页列表页面
    时间：2020-05-20
    Created by yefan
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<div class="w-page-header">
				<search-area ref="searchContent"
							 :showMore="false"
							 v-model="searchForm.sname"
							 placeholderName="模板名称"
							 @on-search="onSearch"
							 @on-refresh="onRefresh"
							 @on-reset="onReset">
				</search-area>
				<div class="btnGroups ml10">
					<el-button type="primary"
							   size="small"
							   @click="addTemplate">添加模板</el-button>
				</div>
			</div>
		</div>
		<div class="w-page-container">
			<div class="w-table-layout w-table-page">
				<transition name="fade"
							mode="out-in">
					<!-- 列表 -->
					<div class="list-wrap w-table-content"
						 ref="tableContent"
						 key="list">
						<el-table :data="tableObj.tableData"
								  row-key="id"
								  v-loading="tableObj.loading"
								  ref="tableObj"
								  default-expand-all
								  :height="tableObj.tableH"
								  border
								  highlight-current-row>
							<el-table-column type="index"
											 lable="序号"
											 align="center"
											 width="100"></el-table-column>
							<el-table-column prop="code"
											 label="模板编号"
											 align="center"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="sname"
											 label="模板名称"
											 align="center"
											 show-overflow-tooltip
											 min-width="150"></el-table-column>
							<el-table-column prop="conditions"
											 label="模板应用"
											 align="center"
											 show-overflow-tooltip
											 min-width="150"></el-table-column>
							<el-table-column prop="isFlag"
											 label="启用开关"
											 align="center"
											 show-overflow-tooltip
											 min-width="80">
								<template slot-scope="scope">
									<el-switch v-model="scope.row.isFlag"
											   :active-value="1"
											   :inactive-value="0"
											   active-color="#0BEEAD"
											   inactive-color="#B9B9B9"
											   @change="changeSwitch(scope.row)" />
								</template>
							</el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 width="120">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   type="text"
											   @click="doClick(scope.row,'edit')"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</transition>

				<!-- 底部分页 -->
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="tableObj.currentPage"
								   :page-sizes="tableObj.pageList"
								   :page-size="tableObj.pageSize"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="tableObj.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getAnalysisTemplates,
	changeTemplateFlag
} from '@/api/modules/analysis.js'

export default {
	data() {
		return {
			searchForm: {
				sname: ''
			},
			tableObj: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			}
		}
	},

	created() {
		this.getTablePageList()
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},

	// 进入缓存页面触发
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},

	methods: {
		//编辑按钮事件
		doClick(row, type) {
			this.$router.push({
				name: 'Template-edit',
				query: {
					type: 3,
					id: row.id
				}
			})
		},

		//加载列表数据
		getTablePageList() {
			let that = this
			let param = {}
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			param.sname = this.searchForm.sname
			param.type = '3'
			getAnalysisTemplates(param).then(res => {
				if (res.code == 0) {
					that.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				} else {
					this.$message.error(res.msg)
				}
			})
		},

		//启用开关change事件
		changeSwitch(row) {
            changeTemplateFlag(row).then(res => {
                if (res.code !== 0) this.$message.error(res.msg)
            })
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTablePageList()
		},

		// 确认搜索
		onSearch() {
			this.getTablePageList()
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.sname = ''
		},

		// 点击新增模板
		addTemplate() {
			this.$router.push({
				name: 'Template-add',
				query: {
					type: 3,
					id: ''
				}
			})
		}
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		}
	}
}
</script>

<style scoped>
</style>